/**
 * Numeric input limits for the crop-year economics fields, shared by every form that writes them
 * (CropDetailsInputDrawer, the Detailed Calculations edit table) so two editors cannot disagree on
 * what they accept. `max` is a typo guard, not an agronomic limit.
 */
export const CROP_YEAR_FIELD_LIMITS = {
  yield: { precision: 2, step: 0.1, min: 0, max: 500 },
  sellingPrice: { precision: 2, step: 0.5, min: 0, max: 10000 },
  fodderLosses: { precision: 1, step: 1, min: 0, max: 100 },
  mouldLosses: { precision: 1, step: 1, min: 0, max: 100 },
  seedCosts: { precision: 2, step: 1, min: 0, max: 2000 },
  seedAmount: { precision: 2, step: 1, min: 0, max: 10000 },
  // Lowest ceiling of the set because the unit is per kg N, which looks like a per-hectare figure but is ~100x smaller.
  minFertiliser: { precision: 2, step: 1, min: 0, max: 50 },
  plantProtection: { precision: 2, step: 1, min: 0, max: 5000 },
  ccCost: { precision: 2, step: 1, min: 0, max: 5000 },
  legumeShare: { precision: 1, step: 1, min: 0, max: 100 },
} as const;

// Placeholder range for the project-level diesel price, pending product sign-off.
export const MACHINERY_DIESEL_LIMITS = { min: 0, max: 500 } as const;
